export default function HowUrgentSection() {
  return (
    <section className="py-14 md:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-bold text-[#2D2D2D] mb-4">
            First — How Much Time Do You Have?
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-3xl mx-auto">
            Your options depend entirely on your travel date. Here's what's realistic at each timeline.
          </p>
        </div>

        <div className="space-y-6">
          {/* Tier 1 — Less than 48 Hours */}
          <div className="bg-red-50 border-l-4 border-red-500 rounded-lg p-5 md:p-7">
            <div className="flex flex-col md:flex-row md:items-start gap-4">
              <div className="flex-shrink-0 w-14 h-14 flex items-center justify-center bg-red-500 rounded-full">
                <i className="ri-alarm-line text-white text-2xl"></i>
              </div>
              <div className="flex-1">
                <h3 className="text-lg md:text-xl font-bold text-red-800 mb-2">
                  Less than 48 Hours — True Emergency
                </h3>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  This is a true emergency. Call us immediately at 877-253-0084. We'll assess your situation in real time. Same-day document submission may be required. Whether we can help depends on what day it is and what type of passport you need.
                </p>
                <a
                  href="tel:8772530084"
                  className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-md transition-colors cursor-pointer text-sm"
                >
                  <i className="ri-phone-fill"></i>
                  Call Now
                </a>
              </div>
            </div>
          </div>

          {/* Tier 2 — 3–5 Days */}
          <div className="bg-amber-50 border-l-4 border-amber-500 rounded-lg p-5 md:p-7">
            <div className="flex flex-col md:flex-row md:items-start gap-4">
              <div className="flex-shrink-0 w-14 h-14 flex items-center justify-center bg-amber-500 rounded-full">
                <i className="ri-flashlight-line text-white text-2xl"></i>
              </div>
              <div className="flex-1">
                <h3 className="text-lg md:text-xl font-bold text-amber-800 mb-2">
                  3–5 Days — Very Urgent but Very Manageable
                </h3>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  Our 3-business-day processing tier handles most situations in this window. Start your order now or call us — time matters here. Processing: 3 business days from document receipt.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-amber-600 hover:bg-amber-700 text-white font-semibold rounded-md transition-colors cursor-pointer text-sm"
                >
                  <i className="ri-arrow-right-line"></i>
                  Start Order
                </a>
              </div>
            </div>
          </div>

          {/* Tier 3 — 1–2 Weeks */}
          <div className="bg-orange-50 border-l-4 border-orange-400 rounded-lg p-5 md:p-7">
            <div className="flex flex-col md:flex-row md:items-start gap-4">
              <div className="flex-shrink-0 w-14 h-14 flex items-center justify-center bg-orange-400 rounded-full">
                <i className="ri-calendar-line text-white text-2xl"></i>
              </div>
              <div className="flex-1">
                <h3 className="text-lg md:text-xl font-bold text-orange-800 mb-2">
                  1–2 Weeks — Our Most Common Urgent Scenario
                </h3>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  Our 4–7 business day tiers work perfectly for this window. Don't wait — start now and you'll have your passport well before your trip. Processing: 4–7 business days from document receipt.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-md transition-colors cursor-pointer text-sm"
                >
                  <i className="ri-arrow-right-line"></i>
                  Start Order
                </a>
              </div>
            </div>
          </div>

          {/* Tier 4 — 2–4 Weeks */}
          <div className="bg-emerald-50 border-l-4 border-emerald-500 rounded-lg p-5 md:p-7">
            <div className="flex flex-col md:flex-row md:items-start gap-4">
              <div className="flex-shrink-0 w-14 h-14 flex items-center justify-center bg-emerald-500 rounded-full">
                <i className="ri-check-line text-white text-2xl"></i>
              </div>
              <div className="flex-1">
                <h3 className="text-lg md:text-xl font-bold text-emerald-800 mb-2">
                  2–4 Weeks — You Have Time But Don't Wait
                </h3>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  Standard government processing (4–6 weeks plus mailing) won't make it. Our 9-business-day or 3–5 week tiers give you a comfortable buffer. Processing: 9 business days to 3–5 weeks.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold rounded-md transition-colors cursor-pointer text-sm"
                >
                  <i className="ri-arrow-right-line"></i>
                  Start Order
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}